/* 07/09/2020 - Gunavant Jambu

    The class defined here will be responsible for keeping in memory the attributes of selected product
    it will be used across multiple sub projects like ApplyNow and Contact Us. 
    For that, the localStorage class will be used.
	
	Things that will be held in localStorage
	
	 - 
	 - User selected product with quotes

*/
import {Component} from "react";

class ProductDetails extends Component {
  /*  static loanType; // string,
    static loanTerm; // int,  
    static productCode; // string
    static loanAmount; //int
    static price; //float
    static rate; // float
    static margin; //int
    static lockPeriod; // int
    static estClosingCost; // int
    static credit; // float
    static apr; // float
    static PI; // float*/



    constructor(props)
	{
		super(props);
		
		this.loadSelectedProductData();		
		
    }
    loadSelectedProductData()
	{
        /* 
            When the class is loaded make sure get read first from the local storage if nothing is found then set default.
		*/
        this.loanType = localStorage.getItem("loanType") || "";
        this.loanTypeCode = localStorage.getItem("loanTypeCode") || "";
        this.loanTerm = localStorage.getItem("loanTerm") || 0;
        this.productCode = localStorage.getItem("productCode") || "";
        this.loanAmount = localStorage.getItem("loanAmount") || 0;
        this.price = localStorage.getItem("price") || 0;
        this.rate = localStorage.getItem("rate") || 0;
        this.margin = localStorage.getItem("margin") || 0;
        this.lockPeriod = localStorage.getItem("lockPeriod") || 0;
        this.estClosingCost = localStorage.getItem("estClosingCost") || 0;
        this.credit = localStorage.getItem("credit") || 0;
        this.apr = localStorage.getItem("apr") || 0;
        this.PI = localStorage.getItem("PI") || 0;
    }

   setLoanType(loanType) {
        this.loanType = loanType.toUpperCase(); 
             
        switch (this.loanType)
		{			
				//no default
                case "CONVENTIONAL":
                    this.loanTypeCode = "200";
                    this.loanType = "FNMA";
                    localStorage.setItem("loanType", "FNMA");
                    localStorage.setItem("loanTypeCode", this.loanTypeCode);
                    break;
                case "FHA":
                    this.loanTypeCode = "110";
                    localStorage.setItem("loanType", "FHA");
                    localStorage.setItem("loanTypeCode", this.loanTypeCode);
                    break;
                case "VA":
                    this.loanTypeCode = "120";
                    localStorage.setItem("loanType", "VA");
                    localStorage.setItem("loanTypeCode", this.loanTypeCode);
                    break;
		}      
        
	}
	getLoanType() {
		return this.loanType;
    }

    setLoanTypeCode(loanTypeCode) {
        this.loanTypeCode = loanTypeCode;
        localStorage.setItem("loanTypeCode", this.loanTypeCode );
    }
    
    getLoanTypeCode(){
        return this.loanTypeCode;
    }

    setLoanTerm(loanTerm) {
		this.loanTerm = loanTerm;
		localStorage.setItem("loanTerm", this.loanTerm);
	}
	getLoanTerm() {
		return this.loanTerm;
    }
    

    getProductCode(){
        return this.productCode;
    }

    setProductCode(productCode) {
        this.productCode = productCode;
        localStorage.setItem("productCode", this.productCode);
    }

    getLoanAmount(){
        return this.loanAmount;
    }

    setLoanAmount(loanAmount) {
        this.loanAmount = loanAmount;
        localStorage.setItem("loanAmount", this.loanAmount);
    }

    getPrice() {
        return this.price;
    }

    setPrice(price){
        this.price = price;
        localStorage.setItem("price", this.price);
    }

    getRate() {
        return this.rate;
    }

    setRate(rate) {
        this.rate = rate;
        localStorage.setItem("rate", this.rate);
    }


    getMargin(){
        return this.margin;
    }

    setMargin(margin){
        this.margin = margin;
        localStorage.setItem("margin", this.margin);
    }

    getLockPeriod() {
        return this.lockPeriod;
    }

    setLockPeriod(lockPeriod) {
        this.lockPeriod = lockPeriod;
        localStorage.setItem("lockPeriod", this.lockPeriod);
    }

    getEstClosingCost() {
        return this.estClosingCost;
    }

    setEstClosingCost(estClosingCost) {
        this.estClosingCost = estClosingCost;
        localStorage.setItem("estClosingCost", this.estClosingCost);
    }

    getCredit(){
        return this.credit;
    }

    setCredit(credit){
        this.credit = credit;
        localStorage.setItem("credit", this.credit);
    }

    getApr(){
        return this.apr;
    }

    setApr(apr) {
        this.apr = apr;
        localStorage.setItem("apr", this.apr);
    }

    getPI() {
        return this.PI;
    }

    setPI(PI){
        this.PI = PI;
        localStorage.setItem("PI", this.PI);
    }
	

};
export default ProductDetails;